// extracted by mini-css-extract-plugin
module.exports = {"header":"CopyFeature_header__f9hsO","content":"CopyFeature_content__2TReH","text":"CopyFeature_text__3dtJS"};